module.exports = __webpack_public_path__ + "static/img/emt_example_payment7.110ed37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emt_example_payment7.jpg
// module id = V+I9
// module chunks = 0